import React from "react";

// Flat, colorful, facile.it-style illustrations.
// Mapped from the category's lucide "icon" name to an illustration key.
const ICON_TO_KEY = {
  Wifi: "phone",
  Phone: "phone",
  Smartphone: "phone",
  Router: "modem",
  Signal: "mobile",
  Sun: "solar",
  Zap: "energy",
  Leaf: "energy",
  Flame: "gas",
  Droplet: "water",
  Tv: "tv",
  Globe: "globe",
  ShieldCheck: "shield",
  Wallet: "wallet",
  Car: "car",
  Gift: "gift",
  Home: "house",
  Building2: "house",
};

const C = {
  navy: "#1B2A4A",
  green: "#8CC63F",
  greenDark: "#71AE2A",
  greenLight: "#EAF6DA",
  yellow: "#FFC23C",
  white: "#FFFFFF",
};

function Phone() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <rect x="22" y="14" width="22" height="38" rx="5" fill={C.navy} />
      <rect x="25" y="19" width="16" height="25" rx="2" fill={C.green} />
      <circle cx="33" cy="48" r="1.8" fill={C.greenLight} />
      <path d="M44 22a8 8 0 0 1 8 8" stroke={C.greenDark} strokeWidth="3" strokeLinecap="round" />
      <path d="M44 16a14 14 0 0 1 14 14" stroke={C.yellow} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function Solar() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <circle cx="22" cy="20" r="7" fill={C.yellow} />
      <g stroke={C.yellow} strokeWidth="2.4" strokeLinecap="round">
        <line x1="22" y1="7" x2="22" y2="10" />
        <line x1="10" y1="20" x2="13" y2="20" />
        <line x1="13.5" y1="11.5" x2="15.5" y2="13.5" />
        <line x1="30.5" y1="11.5" x2="28.5" y2="13.5" />
      </g>
      <path d="M16 38h32l5 14H11z" fill={C.navy} />
      <g stroke={C.green} strokeWidth="1.8">
        <line x1="20" y1="38" x2="18" y2="52" />
        <line x1="32" y1="38" x2="32" y2="52" />
        <line x1="44" y1="38" x2="46" y2="52" />
        <line x1="14.5" y1="45" x2="49.5" y2="45" />
      </g>
    </svg>
  );
}

function Energy() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <circle cx="32" cy="26" r="13" fill={C.yellow} />
      <path d="M34 17l-8 11h5l-1 8 9-12h-5z" fill={C.navy} />
      <rect x="27" y="38" width="10" height="6" rx="2" fill={C.navy} />
      <rect x="28.5" y="44" width="7" height="4" rx="2" fill={C.greenDark} />
    </svg>
  );
}

function Tv() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <rect x="12" y="16" width="40" height="28" rx="4" fill={C.navy} />
      <rect x="16" y="20" width="32" height="20" rx="2" fill={C.green} />
      <path d="M29 26v8l8-4z" fill={C.white} />
      <rect x="26" y="44" width="12" height="3" rx="1.5" fill={C.navy} />
      <rect x="20" y="49" width="24" height="3" rx="1.5" fill={C.navy} />
    </svg>
  );
}

function House() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <path d="M14 31L32 16l18 15z" fill={C.greenDark} />
      <rect x="19" y="31" width="26" height="20" rx="2" fill={C.navy} />
      <rect x="28" y="39" width="8" height="12" fill={C.green} />
    </svg>
  );
}

function Generic() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <circle cx="32" cy="32" r="16" fill={C.navy} />
      <path d="M34 22l-9 12h6l-1 8 10-13h-6z" fill={C.green} />
    </svg>
  );
}

function Modem() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <line x1="23" y1="34" x2="19" y2="19" stroke={C.navy} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="18.5" cy="18" r="2.6" fill={C.greenDark} />
      <line x1="35" y1="34" x2="41" y2="19" stroke={C.navy} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="41.5" cy="18" r="2.6" fill={C.greenDark} />
      <path d="M45 15a6 6 0 0 1 2 6" stroke={C.yellow} strokeWidth="2" strokeLinecap="round" />
      <rect x="14" y="33" width="36" height="14" rx="3.5" fill={C.navy} />
      <circle cx="21" cy="40" r="1.7" fill={C.green} />
      <circle cx="27" cy="40" r="1.7" fill={C.green} />
      <circle cx="33" cy="40" r="1.7" fill={C.yellow} />
    </svg>
  );
}

function Sim() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <path d="M21 16h15l8 8v22a3 3 0 0 1-3 3H21a3 3 0 0 1-3-3V19a3 3 0 0 1 3-3z" fill={C.navy} />
      <rect x="25" y="29" width="14" height="14" rx="2" fill={C.green} />
      <g stroke={C.navy} strokeWidth="1.6">
        <line x1="32" y1="29" x2="32" y2="43" />
        <line x1="25" y1="36" x2="39" y2="36" />
      </g>
    </svg>
  );
}

function Gas() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <path d="M33 14c6 7 11 11 11 19a12 12 0 1 1-24 0c0-4 2-8 5-10 0 3 2 5 4 5-2-5 0-10 4-14z" fill={C.green} />
      <path d="M32 31c3 3 6 5 6 9a6 6 0 1 1-12 0c0-3 3-5 6-9z" fill={C.yellow} />
    </svg>
  );
}

function Water() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <path d="M32 14c7 9 12 15 12 22a12 12 0 1 1-24 0c0-7 5-13 12-22z" fill={C.green} />
      <path d="M26 37a6 8 0 0 0 4 8" stroke={C.white} strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}

function Globe() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <circle cx="32" cy="32" r="17" fill={C.green} />
      <g stroke={C.white} strokeWidth="1.8" fill="none">
        <ellipse cx="32" cy="32" rx="7.5" ry="17" />
        <line x1="15" y1="32" x2="49" y2="32" />
        <path d="M18 24h28" />
        <path d="M18 40h28" />
      </g>
    </svg>
  );
}

function Shield() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <path d="M32 14l14 5v11c0 9-6 15-14 18-8-3-14-9-14-18V19z" fill={C.navy} />
      <path d="M25 32l5 5 9-10" stroke={C.green} strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function Wallet() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <rect x="15" y="22" width="34" height="22" rx="4" fill={C.navy} />
      <path d="M15 26a4 4 0 0 1 4-4h22l-6 6H15z" fill={C.greenDark} />
      <rect x="36" y="30" width="13" height="8" rx="2" fill={C.green} />
      <circle cx="42.5" cy="34" r="1.8" fill={C.navy} />
    </svg>
  );
}

function Car() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <path d="M17 38l3-9a4 4 0 0 1 4-3h16a4 4 0 0 1 4 3l3 9z" fill={C.green} />
      <rect x="13" y="37" width="38" height="9" rx="3" fill={C.navy} />
      <circle cx="22" cy="46" r="3.6" fill={C.navy} />
      <circle cx="22" cy="46" r="1.5" fill={C.greenLight} />
      <circle cx="42" cy="46" r="3.6" fill={C.navy} />
      <circle cx="42" cy="46" r="1.5" fill={C.greenLight} />
    </svg>
  );
}

function Gift() {
  return (
    <svg viewBox="0 0 64 64" fill="none" className="w-full h-full">
      <circle cx="32" cy="32" r="30" fill={C.greenLight} />
      <rect x="17" y="29" width="30" height="20" rx="2" fill={C.navy} />
      <rect x="15" y="23" width="34" height="8" rx="2" fill={C.greenDark} />
      <rect x="29" y="23" width="6" height="26" fill={C.green} />
      <path d="M32 23c-2.5-4.5-9-3-7 1 1.2 2.3 5 1.2 7-1zm0 0c2.5-4.5 9-3 7 1-1.2 2.3-5 1.2-7-1z" fill={C.yellow} />
    </svg>
  );
}

const KEY_TO_COMP = {
  phone: Phone, solar: Solar, energy: Energy, tv: Tv, house: House,
  modem: Modem, mobile: Sim, gas: Gas, water: Water, globe: Globe,
  shield: Shield, wallet: Wallet, car: Car, gift: Gift, generic: Generic,
};

export function CategoryIllustration({ icon, className = "w-16 h-16" }) {
  const key = ICON_TO_KEY[icon] || "generic";
  const Comp = KEY_TO_COMP[key];
  return (
    <span className={`inline-block ${className}`}>
      <Comp />
    </span>
  );
}
